import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Card, CardContent } from "../ui/card";
import { HOME } from "../../constants/testIds";

function StatCell({ label, value, testId }) {
  return (
    <div className="flex flex-col gap-1">
      <span className="text-[10px] font-medium uppercase tracking-[0.18em] text-muted-foreground">
        {label}
      </span>
      <span data-testid={testId} className="text-sm font-medium">
        {value ?? "—"}
      </span>
    </div>
  );
}

export default function ConnectionBadge({ isLoading, isError, data, error }) {
  const connected = !!data?.connected && !isError;

  return (
    <Card className="border-border">
      <CardContent className="flex flex-col gap-6 p-6 md:flex-row md:items-center md:justify-between">
        <div className="flex items-center gap-4">
          <div
            data-testid={HOME.connectionBadge}
            data-status={
              isLoading ? "loading" : connected ? "connected" : "error"
            }
            className={[
              "flex h-11 w-11 items-center justify-center rounded-full border",
              isLoading
                ? "border-border text-muted-foreground"
                : connected
                  ? "border-emerald-600/40 bg-emerald-600/10 text-emerald-700 dark:text-emerald-400"
                  : "border-destructive/40 bg-destructive/10 text-destructive",
            ].join(" ")}
          >
            {isLoading ? (
              <Loader2 className="h-5 w-5 animate-spin" />
            ) : connected ? (
              <CheckCircle2 className="h-5 w-5" />
            ) : (
              <XCircle className="h-5 w-5" />
            )}
          </div>
          <div>
            <div className="text-[10px] font-medium uppercase tracking-[0.2em] text-muted-foreground">
              Shopify Storefront API
            </div>
            <div className="mt-1 text-lg font-semibold">
              {isLoading
                ? "Checking connection…"
                : connected
                  ? "Connection healthy"
                  : "Connection failed"}
            </div>
            {!isLoading && !connected && (
              <div
                data-testid={HOME.connectionError}
                className="mt-1 max-w-lg text-xs text-destructive"
              >
                {String(error?.message || data?.error || "Unknown error")}
              </div>
            )}
          </div>
        </div>

        <div className="grid grid-cols-2 gap-6 sm:grid-cols-3">
          <StatCell
            label="Shop"
            value={data?.shop_name}
            testId={HOME.connectionShopName}
          />
          <StatCell label="Currency" value={data?.currency} />
          <StatCell label="API version" value={data?.api_version} />
        </div>
      </CardContent>
    </Card>
  );
}
